import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"list\"><path fill-rule=\"evenodd\" d=\"M14 10V8h8v2h-8Zm0-6h5v2h-5V4Zm-2 4.5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v3ZM14 20v-2h8v2h-8Zm0-6h5v2h-5v-2Zm-2 4.5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol